<template>
  <div class="roleManage">
    <div class="search">
      <div class="search_box">
        <div class="search_options_box">
          <span style="width: auto;white-space: nowrap">选择项目</span>
          <img src="/static/img/select.png" alt />
          <select >
            <!-- <option v-for="item in projectList" v-bind:value="item.id" v-bind:key="item.id" >{{ item.name }}</option> -->
          </select>
        </div>

        <div class="search_btn_box">
          <div class="search_btn_box">
            <button :class='["search_btn","green","icon_btn","clearborder"]' @click="search()"><span class="el-icon-search"></span>搜索</button>
          </div>
        </div>

        <div class="add_btn_box">
          <button :class='["add_btn","add","icon_btn","clearborder"]'  @click="addRoleBtn"><span class="icon-9"></span>新增角色</button>
          <button :class='["add_btn","delete","icon_btn","clearborder"]' @click="batchDeleteUser(null)"><span class="icon-9"></span>批量删除</button>
        </div>
      </div>
    </div>
    <!--        表格-->
    <div class="table_content">
      <table>
        <thead>
          <tr>
            <th style="padding-left: 30px">
              <input type="checkbox" name="checkbox" style="width: 16px;height: 16px" />
            </th>
            <th>序号</th>
            <th>角色名</th>
            <th>状态</th>
            <th>权限</th>
            <th>创建时间</th>
            <th>最近修改时间</th>
            <th>管理</th>
          </tr>
        </thead>
        <tbody v-for="(item,index) in currentPageData" :key="index">
          <tr>
            <td style="padding-left: 30px">
              <input type="checkbox" name="checkbox" v-model="selectedUsers" :value="item.id"/>
            </td>
            <td>{{index+1}}</td>
            <td>{{item.name}}</td>
            <td v-if="item.status==='0'">禁用</td>
            <td v-if="item.status==='1'">启用</td>
            <td>{{item.create_datetime}}</td>
            <td>{{item.update_datetime}}</td>
            <td>{{item.update_datetime}}</td>
            <td class="table_btn_box">
              <button class="table_btn" style=" margin-right: 20px;" @click="updateUserBtn(item)">编辑</button>
              <button class="table_btn" @click="deleteUser(item.id)">删除</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
   <div class="table_paging">
        <p>当前记录<span>{{(this.currentPage-1)*9+1}}</span>到<span>{{(this.currentPage-1)*9+this.currentPageData.length}}</span>条，共<span>{{this.totalCount}}</span>条记录
          <button @click="FirstPage()"
            v-bind:style="[{background:'url(/static/img/icon/table_start.png) no-repeat center center'}]"></button>
          <button
            @click="prevPage()" v-bind:style="[{background:'url(/static/img/icon/table_prep.png) no-repeat center center'}]"></button>
          第<span>{{currentPage}}</span>/<span>{{Math.ceil(totalCount/pageSize)}}</span>页
          <button
            @click="nextPage()" v-bind:style="[{background:'url(/static/img/icon/table_next.png) no-repeat center center'}]"></button>
          <button @click="LastPage()"
            v-bind:style="[{background:'url(/static/img/icon/table_end.png) no-repeat center center'}]"></button>
        </p>
    </div>
    <!--    添加角色-->
    <transition name="fade">
      <div class="mark" v-if="addRoleShow">
        <div class="mark_close" @click="addRoleShow=!addRoleShow"></div>
        <div :class='["information_box","light_border","weather_box"]'
             :style="[{width:'600px'},{'margin-top':'0px'}]">
          <div class="border_top_left"></div>
          <div class="border_top_right"></div>
          <div class="border_bottom_left"></div>
          <div class="border_bottom_right"></div>
          <div class="h_light_right" :style="{top:'95px'}"></div>
          <div class="information_content issue_search_box model" >
            <h1>添加用户</h1>
            <label>角色名称：</label><input type="text" v-model="currentRole.name" class="input_border" placeholder="请输入角色名称"><br>
            <label class="js">角色状态：</label>
            <select v-model="currentRole.status" class="input_border select_width" >
                <option value ="1">启用</option>
                <option value ="0">禁用</option>
            </select>
            <label class="js jst">角色状态：</label>
            <div class="cycle" style="width：500px;">
                <div class="check_box">
                  <div class="input_w"><input type="checkbox" name="limit_weekday" value="1"><span>智慧照明</span></div>
                  <div class="input_w"><input type="checkbox" name="limit_weekday" value="5"><span>无线WIFI(运营)</span></div>
                  <div class="input_w"><input type="checkbox" name="limit_weekday" value="5"><span>无线WIFI(非运营)</span></div>
                </div>
                <div class="check_box">
                  <div class="input_w"><input type="checkbox" name="limit_weekday" value="2"><span>环境监测</span></div>
                  <div class="input_w"><input type="checkbox" name="limit_weekday" value="5"><span>智能音箱(运营)</span></div>
                  <div class="input_w"><input type="checkbox" name="limit_weekday" value="5"><span>智能音箱(非运营)</span></div> 
                </div>
                <div class="check_box">
                   <div class="input_w"><input type="checkbox" name="limit_weekday" value="3"><span>智慧安防</span></div> 
                  <div class="input_w"><input type="checkbox" name="limit_weekday" value="5"><span>信息发布(运营)</span></div>
                  <div class="input_w"><input type="checkbox" name="limit_weekday" value="5"><span>信息发布(非运营)</span></div>
                </div>
                <div class="check_box">
                  <div class="input_w"><input type="checkbox" name="limit_weekday" value="4"><span>一键报警</span></div>
                  <div class="input_w"><input type="checkbox" name="limit_weekday" value="5"><span>充电桩(运营)</span></div>
                  <div class="input_w"><input type="checkbox" name="limit_weekday" value="5"><span>充电桩(非运营)</span></div>
                </div>
            </div>

            <div class="sbt_box">
              <button :class='["add_btn","delete","icon_btn","clearborder"]' @click="addRoleShow=!addRoleShow">取消</button>
              <button :class='["add_btn","add","icon_btn","clearborder"]' @click="confirmAddUser()">确定</button>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <!--    修改用户-->
    <transition name="fade">
      <div class="mark" v-if="updateUserShow">
        <div class="mark_close" @click="updateUserShow=!updateUserShow"></div>
        <div :class='["information_box","light_border","weather_box"]'
             :style="[{width:'500px'},{'margin-top':'0px'}]">
          <div class="border_top_left"></div>
          <div class="border_top_right"></div>
          <div class="border_bottom_left"></div>
          <div class="border_bottom_right"></div>
          <div class="h_light_right" :style="{top:'95px'}"></div>
          <div class="information_content issue_search_box model">
            <h1>修改用户</h1>
            <label>用户名称：</label><input type="text" v-model="currentRole.name" class="input_border" placeholder="请输入用户名称"><br>
            <label>手机号：</label><input type="text" v-model="currentRole.mobile" class="input_border" placeholder="请输入用户名称"><br>
            <label>用户状态：</label><input type="text" v-model="currentRole.status" class="input_border" placeholder="请输入用户名称"><br>
            <label>所属角色：</label>
            <select v-for="(item,index) in roleList" :key="index" v-model="currentRole.role_id" class="input_border select_width1">
              <option :value ="item.id">{{item.name}}</option>
            </select>
            <div class="sbt_box">
              <button :class='["add_btn","delete","icon_btn","clearborder"]' @click="updateUserShow=!updateUserShow">取消</button>
              <button :class='["add_btn","add","icon_btn","clearborder"]' @click="confirmUpdateUser()">确定</button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "roleManage",
  data() {
    return {
      totalCount: 0, // 总记录条数
      pageSize: 9, // 每页显示数量
      currentPage: 1, //当前页数 ，默认为1
      currentPageData: [],
      addRoleShow:false,
      updateUserShow:false,
      currentRole:{role_id:"",name:"",status:""},
      roleList:[],
      selectedUsers:[]
    };
  },
  methods: {
    batchDeleteUser: function (user_id) {
      var user_list = [];
      if(user_id == null){
        user_list = this.selectedUsers;
      }else{
        user_list = [user_id];
      }
      fetch("/api/v1/user/delete", {
        method: 'post',
        body: JSON.stringify({
          user_id: user_list
        })
      }).then(result => {
          return result.json();//解析流
      }).then(data => {
          if (data.code == "200") {
            this.getUserList();
          } 
      }).catch((error) => {
          console.log(error);
      });
    },    
    deleteUser: function (user_id) {
      this.batchDeleteUser(user_id)
    },
    confirmAddUser: function () {
      fetch("/api/v1/user/add", {
        method: 'post',
        body: JSON.stringify({
          name: this.currentRole.name,
          mobile: this.currentRole.mobile,
          password: this.currentRole.password,
          status: this.currentRole.status,
          role_id: this.currentRole.role_id,
        })
      }).then(result => {
          return result.json();//解析流
      }).then(data => {
          if (data.code == "200") {
            this.getUserList();
          } 
      }).catch((error) => {
          console.log(error);
      });
      this.addUserShow=!this.addUserShow;
    },
    confirmUpdateUser: function () {
      fetch("/api/v1/user/update", {
        method: 'post',
        body: JSON.stringify({
          user_id: this.currentRole.user_id,
          name: this.currentRole.name,
          mobile: this.currentRole.mobile,
          status: this.currentRole.status,
          role_id: this.currentRole.role_id,
        })
      }).then(result => {
          return result.json();//解析流
      }).then(data => {
          if (data.code == "200") {
            console.log(data.msg);
            this.getUserList();

          } 
      }).catch((error) => {
          console.log(error);
      });
      this.updateUserShow=!this.updateUserShow;
    },
    addRoleBtn:function(){
        this.addRoleShow=!this.addRoleShow;
        this.getRoleList();
    },
    updateUserBtn:function(user){
        this.updateUserShow=!this.updateUserShow;
        this.getRoleList();
        this.currentRole.user_id=user.id,
        this.currentRole.name=user.name,
        this.currentRole.mobile=user.mobile,
        this.currentRole.status=user.status,
        this.currentRole.role_id=user.role_id
    },
    getRoleList: function () {
      fetch("/api/v1/sys/role/list", {
        method: 'post',
        body: JSON.stringify({
          page_start: this.currentPage-1,
          page_size: this.pageSize,
        })
      }).then(result => {
          return result.json();//解析流
      }).then(data => {
          if (data.code == "200") {
            this.totalCount = data.total_count;
            this.currentPageData = data.data;
          } 
      }).catch((error) => {
          console.log(error);
      });
    },
    //上一页
    prevPage() {
      if (this.currentPage == 1) {
        return false;
      } else {
        this.currentPage--;
        this.getUserList();
      }
    },
    // 下一页
    nextPage() {
      if (this.currentPage == Math.ceil(this.totalCount/this.pageSize)) {
        return false;
      } else {
        this.currentPage++;
        this.getUserList();
      }
    },
    FirstPage(){
        this.currentPage = 1;
        this.getUserList();
    },
    LastPage(){
      this.currentPage = Math.ceil(this.totalCount/this.pageSize);
      this.getUserList();
    },
  },
  mounted() {
    // this.InitLeftMenu();
    this.getRoleList();
  },
  created() {},
  destroyed: function() {}
};
</script>

<style scoped>
.userManage {
  width: 100%;
  height: 100%;
  padding: 0 20px;
  box-sizing: border-box;
}
.search {
  width: 100%;
  height: 100px;
  padding: 20px 0px 0px;
}

.search_box {
  width: 100%;
  height: 100%;
  margin-right: 10px;
  background: #16518d;
  border-radius: 6px;
  float: left;
  display: flex;
  align-items: center;
  padding: 0 10px;
  box-sizing: border-box;
  position: relative;
}

.search_options_box {
  width: 16%;
  padding: 0 10px;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.search_options_box > span {
  width: 64px;
  margin-right: 8px;
  text-align: right;
  color: #ffffff;
}

.search_options_box > select {
  width: calc(100% - 72px);
  height: 36px;
  border-radius: 6px;
  background: transparent;
  border: 1px solid #ffffff;
  color: #ffffff;
  appearance: none;
  padding-left: 10px;
  font-size: 16px;
  outline: none;
  cursor: pointer;
}

.search_options_box option {
  color: #000000;
}

.search_options_box > img {
  position: absolute;
  top: 48px;
  right: 20px;
  cursor: pointer;
}

.search_btn_box {
  width: 80px;
  padding: 10px;
}

.clearborder {
  outline: none;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
}

.search_btn {
  width: 100%;
  height: 32px;
  border-radius: 6px;
  line-height: 32px;
}

.add_btn {
  width: 110px;
  height: 32px;
  border-radius: 6px;
  line-height: 32px;
  float: right;
  margin-right: 20px;
}

.icon_btn span {
  margin-right: 8px;
}

.green {
  background: #21b868;
  color: #ffffff;
}

.green:active {
  background: #15a95a;
}

.add_btn_box {
  /*width: 370px;*/
  padding: 10px;
  position: absolute;
  right: 0px;
}

.add {
  background: #7aafeb;
  color: #ffffff;
  box-shadow: 0px 3px 0px #3574ba;
}

.add:active {
  background: #6ca3e2;
}

.delete {
  background: #f2ae4d;
  color: #ffffff;
  box-shadow: 0px 3px 0px #dc8509;
}

.delete:active {
  background: #e7a342;
}
.table_content {
  width: 100%;
  padding: 20px 0px;
}

.table_content > table {
  width: 100%;
  height: 100%;
  border: 1px solid #094b8e;
  background-color: #16518d;
}

.table_content > table tr th {
  background-color: #0e345b;
}
/* .table_content > table tr td {
  background-color: #16518d;
} */

.table_content > table tr td input {
  width: 16px;
  height: 16px;
}

.table_content > table tr:nth-child(2n) {
  background-color: #11406f;
}

.table_content > table tr {
  /*border-bottom: 1px solid #225892;*/
  height: 62px;
}

.table_content > table tr td,
.table_content > table tr th {
  text-align: center;
  color: #ffffff;
}

.table_paging {
  height: 60px;
  width: 100%;
  display: flex;
  align-items: center;
  border: 1px solid #105ba8;
  border-radius: 6px;
}

.table_paging > p {
  width: 100%;
  height: 30px;
  line-height: 30px;
  text-align: right;
  margin-bottom: 0;
  color: #c1c2c6;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 10px;
}

.table_paging > p > button {
  margin: 0 8px;
  width: 10px;
  height: 16px;
  border: none;
  outline: none;
}

.table_btn {
  color: #95bee5;
  background: transparent;
  border: 1px solid #95bee5;
  outline: transparent;
  padding: 5px 20px;
  border-radius: 6px;
}
.information_content label{
  width: 20% !important;
  text-align: right;
  color: #ffffff;
}
.information_content .js{
  width: 19% !important;
  text-align: right;
  color: #ffffff;
}
.input_border{
  border-radius: 4px;
  border:1px solid #556e88 !important;
  background:none;
  padding-left: 10px;
  height: 32px;
  margin: 10px 0 10px 0;
  width: 73%;
  color:#ffffff;
}
.select_width{
  width:76%;
}
.select_width1{
  width:74.5%;
}
.information_content select{
  color: #ffffff;
}
.cycle{
  width: 140%;
}
.cycle input{
    margin: 10px 0 0 0;
    width: 18px !important;
    height: 18px !important;
}
.cycle span{
    color: #ffffff;
    margin:0 10px 4px 4px;
}
.check_box{
    height: 50px;
    margin-left: 30px;
}
.input_w{
  float: left;
  width: 170px;
}
.jst{
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Setting/role_manage.vue